import { ImageScaleView, View, ViewOpts } from '@play-co/timestep-core/ui';
import { downscale } from 'src/conf/scale';
import i18n from 'src/lib/i18n/i18n';
import ButtonScaleView from 'src/lib/ui/components/ButtonScaleView';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { Feature } from 'src/replicant/analytics';

export class ChampionsLeagueButtonHome extends ButtonScaleView {
  constructor(opts: ViewOpts & { onClick?: () => Promise<void> }) {
    super({
      ...opts,
      width: 200,
      height: 200,
      pressedOffsetY: 5,
      onClick: opts.onClick,
      tracking: {
        feature: Feature.LEAGUES._,
        $subFeature: Feature.LEAGUES.HOME_BUTTON,
      },
    });

    new ImageScaleView({
      superview: this,
      image: 'assets/ui/championsLeague/buttons/button_home.png',
      scaleMethod: 'contain',
      width: downscale(307),
      height: downscale(287),
      centerOnOrigin: true,
      x: this.style.width * 0.5,
      y: this.style.height * 0.5,
    });

    new LangBitmapFontTextView({
      superview: this,
      centerOnOrigin: true,
      align: 'center',
      verticalAlign: 'center',
      size: 26,
      font: 'Title',
      width: 100,
      height: 50,
      x: this.style.width * 0.5,
      y: this.style.height - 36,
      localeText: () => i18n('championsLeague.home'),
    });
  }
}
